import { Component, Input, OnInit } from '@angular/core';
import {
	FnCheckboxEventFilter,
	FnCheckboxFilterOption,
} from '../../../../event-filter/fn-event-filter.model';

@Component({
	selector: 'fn-grid-check-select-filter',
	templateUrl: './fn-grid-check-select-filter.component.html',
	styleUrls: ['./fn-grid-check-select-filter.component.scss'],
})
export class FnGridCheckSelectFilterComponent {
	@Input() eventFilter: FnCheckboxEventFilter;
	constructor() {}
	selectUnselectOption(
		fnCheckboxEventFilter: FnCheckboxEventFilter,
		fnCheckboxFilterOption: FnCheckboxFilterOption
	) {
		if (fnCheckboxFilterOption.isSelected) {
			fnCheckboxEventFilter.noOfOptionSelected += 1;
			this.pushValueInArray(fnCheckboxFilterOption, fnCheckboxEventFilter);
			if (
				fnCheckboxEventFilter.noOfOptionSelected ===
				fnCheckboxEventFilter.fnFilterOptionArray.length
			) {
				fnCheckboxEventFilter.parentOption.isSelected = true;
				return;
			}
		} else {
			fnCheckboxEventFilter.noOfOptionSelected -= 1;
			fnCheckboxEventFilter.parentOption.isSelected = false;
			for (
				let i = 0;
				i < fnCheckboxEventFilter.selectedOptionArray.length;
				i++
			) {
				if (
					fnCheckboxEventFilter.selectedOptionArray[i] +
						'_' +
						fnCheckboxEventFilter.primaryKey ===
					fnCheckboxFilterOption.primaryKey
				) {
					fnCheckboxEventFilter.selectedOptionArray.splice(i, 1);
					return;
				}
			}
		}
	}
	selectUnSelectAll() {
		this.eventFilter.selectedOptionArray = [];
		const isAllSelected = this.eventFilter.parentOption.isSelected;
		for (let i = 0; i < this.eventFilter.fnFilterOptionArray.length; i++) {
			this.eventFilter.fnFilterOptionArray[i].isSelected = isAllSelected;
			this.pushValueInArray(
				this.eventFilter.fnFilterOptionArray[i],
				this.eventFilter
			);
		}
		if (!isAllSelected) {
			this.eventFilter.selectedOptionArray = [];
		}
		this.eventFilter.noOfOptionSelected = this.eventFilter.selectedOptionArray.length;
	}

	private pushValueInArray(
		fnCheckboxFilterOption: FnCheckboxFilterOption,
		fnCheckboxEventFilter: FnCheckboxEventFilter
	) {
		fnCheckboxEventFilter.selectedOptionArray.push(
			fnCheckboxFilterOption.primaryKey.replace(
				'_' + fnCheckboxEventFilter.primaryKey,
				''
			)
		);
	}
}
